import React from 'react'
import styled from '@emotion/styled'
import FadeDownWrap from 'src/components/atoms/FadeDown'
import ColorButton from 'src/components/atoms/ColorButton'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { vwSize } from 'src/utils/vwCss'
import { Typography } from 'src/components/atoms/Typography'
// image
import bgCta from 'src/images/top/bg_cta.png'
import bgCtaSp from 'src/images/top/bg_cta_sp.png'


const TopCTA = () => {
  return (
    <Container>
      <ContainerInner>
        <FadeDownWrap>
          <CTATitle>
            コミュニティの企画・<br className={"pc-none"} />構築・運用全てをご支援<br />コミュニティサクセス<br className={"pc-none"} />プラットフォーム
          </CTATitle>
        </FadeDownWrap>
        <FadeDownWrap>
          <CTAButton>
            <ButtonWrap className={"g-btn -orange"}>
              <ColorButton
                text="資料ダウンロード"
                to="/whitepapers/commmune_introduction/"
                arrow={false}
                outer={false}
              />
            </ButtonWrap>
          </CTAButton>
        </FadeDownWrap>
      </ContainerInner>
    </Container>
  )
}

const Container = styled.section`
  background-image: url(${bgCta});
  background-repeat; no-repeat;
  background-position; center bottom;
  background-size: cover;
  width: 100%;
  box-sizing: border-box;
  padding: ${vwSize(80, 'pc')}vw 0;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    background-image: url(${bgCtaSp});
    padding: ${vwSize(64, 'sp')}vw 0;
  }
`
const ContainerInner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding-left: ${vwSize(549, 'pc')}vw;
  width: 100%;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    padding-left: 0;
  }
`

const CTATitle = styled(Typography)`
  font-weight: ${Styles.fontWeight.bold};
  font-size:  ${Styles.pc.fontSize.h2};
  color: ${Styles.color.grayscale[100]};
  line-height: 1.6;
  text-align: center;
  letter-spacing: ${Styles.letterSpacing[400]};
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size:  ${Styles.sp.fontSize.h2};
  }
`
const CTAButton = styled(Typography)`
  margin-top: ${vwSize(24, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin-top: ${vwSize(24, 'sp')}vw;
  }
`
const ButtonWrap = styled.div`
`

export default TopCTA
